import React from "react";
import PatientLayout from "../../Layouts/Patient/PatientLayout";


export default function PatientDashboardPremium() {

    const stats = [
        {
            title: "Total Appointments",
            value: 8,
            icon: "bi bi-calendar2-check",
            tone: "primary",
            subText: "All scheduled visits",
        },
        {
            title: "Upcoming",
            value: 2,
            icon: "bi bi-clock-history",
            tone: "success",
            subText: "Next 7 days",
        },
        {
            title: "Reports Available",
            value: 5,
            icon: "bi bi-file-earmark-text",
            tone: "warning",
            subText: "Ready for review",
        },
        {
            title: "Prescriptions",
            value: 4,
            icon: "bi bi-capsule",
            tone: "info",
            subText: "Recent records",
        },
    ];


    return (
        <PatientLayout
            title="My Appointments"
            rightContent={
                <div className="d-flex align-items-center gap-4">
                    
                </div>
            }
        >
            <div className="row g-4 mb-4">
                {stats.map((item) => (
                    <div className="col-12 col-sm-6 col-xl-3" key={item.title}>
                        <div className={`card border-0 shadow-sm rounded-4 h-100 overflow-hidden stat-card stat-${item.tone}`}>
                            <div className="card-body p-5 position-relative">
                                <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                        <div className="text-muted fw-semibold fs-7 text-uppercase mb-2">
                                            {item.title}
                                        </div>
                                        <div className="fs-1 fw-bolder text-dark mb-1">{item.value}</div>
                                        <div className="text-muted fs-7">{item.subText}</div>
                                    </div>

                                    <div
                                        className={`rounded-circle d-flex align-items-center justify-content-center bg-${item.tone}-subtle`}
                                        style={{ width: 62, height: 62 }}
                                    >
                                        <i className={`${item.icon} fs-2 text-${item.tone}`}></i>
                                    </div>
                                </div>

                                <div
                                    className="position-absolute end-0 bottom-0 opacity-10 pe-4 pb-2"
                                    style={{ fontSize: "4rem", lineHeight: 1 }}
                                >
                                    <i className={`${item.icon} text-dark`}></i>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row g-4">
                <div className="col-12 col-xl-6">
                    <div className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden">
                        <div className="card-header border-0 pt-5 pb-0 bg-transparent">
                            <div className="d-flex align-items-center gap-3">
                                <div className="rounded-circle bg-light-primary d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                                    <i className="bi bi-calendar2-check fs-3 text-primary"></i>
                                </div>
                                <div>
                                    <h3 className="mb-1 fw-bold text-dark">Next Appointment</h3>
                                    <div className="text-muted fs-7">Your upcoming confirmed consultation</div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body p-5">
                            <div className="bg-light-primary bg-opacity-25 rounded-4 p-4 mb-4 border border-primary-subtle">
                                <div className="row g-4">
                                    <div className="col-12 col-sm-6">
                                        <div className="text-muted fs-8 text-uppercase fw-bold mb-1">Date</div>
                                        <div className="fw-bolder fs-4 text-dark">5 Mar 2026</div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="text-muted fs-8 text-uppercase fw-bold mb-1">Status</div>
                                        <span className="badge badge-light-success px-4 py-2 rounded-pill fw-bold">
                                            Approved
                                        </span>
                                    </div>
                                    <div className="col-12">
                                        <div className="text-muted fs-8 text-uppercase fw-bold mb-1">Doctor</div>
                                        <div className="fw-semibold fs-5 text-dark">Dr. Anandi Gopal Joshi</div>
                                    </div>
                                    <div className="col-12">
                                        <div className="text-muted fs-8 text-uppercase fw-bold mb-1">Department</div>
                                        <div className="fw-semibold fs-5 text-dark">Cardiology</div>
                                    </div>
                                </div>
                            </div>

                            <div className="progress rounded-pill mb-4" style={{ height: "10px" }}>
                                <div className="progress-bar bg-success w-100"></div>
                            </div>

                            <div className="d-flex gap-3 flex-wrap">
                                <button className="btn btn-warning fw-bold px-4 rounded-3 btn-sm">
                                    <i className="bi bi-arrow-repeat me-2"></i>
                                    Reschedule
                                </button>
                                <button className="btn btn-light-danger fw-bold px-4 rounded-3 btn-sm">
                                    <i className="bi bi-x-circle me-2"></i>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-xl-6">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-header border-0 pt-5 pb-0 bg-transparent">
                            <div className="d-flex align-items-center gap-3">
                                <div className="rounded-circle bg-light-warning d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                                    <i className="bi bi-lightning-charge fs-3 text-warning"></i>
                                </div>
                                <div>
                                    <h3 className="mb-1 fw-bold text-dark">Quick Actions</h3>
                                    <div className="text-muted fs-7">Fast access to the most used actions</div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body p-5">
                            <div className="row g-3">
                                <div className="col-12">
                                    <button className="btn btn-primary w-100 rounded-4 p-4 text-start shadow-sm">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="rounded-circle bg-white bg-opacity-25 d-flex align-items-center justify-content-center" style={{ width: 46, height: 36 }}>
                                                    <i className="bi bi-plus-circle fs-3 text-white"></i>
                                                </div>
                                                <div>
                                                    <div className="fw-bold fs-5">Book New Appointment</div>
                                                    <div className="fs-7 opacity-75">Schedule a fresh consultation</div>
                                                </div>
                                            </div>
                                            <i className="bi bi-arrow-right fs-3"></i>
                                        </div>
                                    </button>
                                </div>

                                <div className="col-12 col-md-6">
                                    <button className="btn btn-light-info w-100 rounded-4 p-4 text-start border h-100">
                                        <div className="d-flex flex-column gap-2">
                                            <i className="bi bi-file-earmark-medical fs-2 text-info"></i>
                                            <div className="fw-bold fs-5 text-dark">Medical Reports</div>
                                            <div className="text-muted fs-7">View uploaded reports</div>
                                        </div>
                                    </button>
                                </div>

                                <div className="col-12 col-md-6">
                                    <button className="btn btn-light-primary w-100 rounded-4 p-4 text-start border h-100">
                                        <div className="d-flex flex-column gap-2">
                                            <i className="bi bi-download fs-2 text-primary"></i>
                                            <div className="fw-bold fs-5 text-dark">Medical History</div>
                                            <div className="text-muted fs-7">Download visit history</div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-xl-6">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-header border-0 pt-5 pb-0 bg-transparent">
                            <div className="d-flex align-items-center gap-3">
                                <div className="rounded-circle bg-light-info d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                                    <i className="bi bi-capsule-pill fs-3 text-info"></i>
                                </div>
                                <div>
                                    <h3 className="mb-1 fw-bold text-dark">Recent Prescriptions</h3>
                                    <div className="text-muted fs-7">Latest medicines and treatment notes</div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body p-5">
                            <div className="d-flex flex-column gap-3">
                                <div className="rounded-4 bg-light p-4 border border-light-subtle">
                                    <div className="d-flex justify-content-between gap-3 flex-wrap">
                                        <div>
                                            <div className="fw-bold text-dark fs-6">Fever Treatment</div>
                                            <div className="text-muted fs-7">Dr. Anandi Gopal Joshi</div>
                                        </div>
                                        <span className="badge badge-light-primary px-3 py-2 rounded-pill">20 Feb 2026</span>
                                    </div>
                                </div>

                                <div className="rounded-4 bg-light p-4 border border-light-subtle">
                                    <div className="d-flex justify-content-between gap-3 flex-wrap">
                                        <div>
                                            <div className="fw-bold text-dark fs-6">General Checkup</div>
                                            <div className="text-muted fs-7">Dr. Mithra</div>
                                        </div>
                                        <span className="badge badge-light-primary px-3 py-2 rounded-pill">05 Feb 2026</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-xl-6">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-header border-0 pt-5 pb-0 bg-transparent">
                            <div className="d-flex align-items-center gap-3">
                                <div className="rounded-circle bg-light-danger d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                                    <i className="bi bi-bell fs-3 text-danger"></i>
                                </div>
                                <div>
                                    <h3 className="mb-1 fw-bold text-dark">Notifications</h3>
                                    <div className="text-muted fs-7">Latest updates from your health account</div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body p-5">
                            <div className="d-flex flex-column gap-3">
                                <div className="rounded-4 border border-success-subtle bg-light-success bg-opacity-50 p-4">
                                    <div className="d-flex align-items-start gap-3">
                                        <i className="bi bi-check2-circle fs-3 text-success"></i>
                                        <div>
                                            <div className="fw-bold text-success">Appointment approved</div>
                                            <div className="text-muted fs-7">Approved for 28 Feb 2026</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="rounded-4 border border-warning-subtle bg-light-warning bg-opacity-50 p-4">
                                    <div className="d-flex align-items-start gap-3">
                                        <i className="bi bi-exclamation-triangle fs-3 text-warning"></i>
                                        <div>
                                            <div className="fw-bold text-warning">Blood test report uploaded</div>
                                            <div className="text-muted fs-7">Your latest lab result is now available</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="rounded-4 border border-danger-subtle bg-light-danger bg-opacity-50 p-4">
                                    <div className="d-flex align-items-start gap-3">
                                        <i className="bi bi-exclamation-circle fs-3 text-danger"></i>
                                        <div>
                                            <div className="fw-bold text-danger">Pending payment</div>
                                            <div className="text-muted fs-7">Payment pending for your last visit</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>
                {`.ant-layout-sider,
                            .card {
                                transition: all 0.25s ease;
                            }

                            .card:hover {
                                transform: translateY(-2px);
                            }
                            .stat-card,
                            .card {
                                transition: transform 0.25s ease, box-shadow 0.25s ease;
                            }

                            .stat-card:hover,
                            .card:hover {
                                transform: translateY(-3px);
                            }
                        `}
            </style>
        </PatientLayout>

    );
}
